var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{attrs:{"color":_vm.color,"indeterminate":"","width":2,"size":20}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }